/**
 * Montaje imperativo del editor sobre un contenedor.
 * Alternativa al Web Component para integraciones que necesitan
 * pasar callbacks u objetos que no encajan en atributos HTML.
 */

import { DeadBugEditorElement, registerDeadBugEditor } from './deadbug-editor.js';
import type { Project } from '../core/model/project.js';

export interface MountOptions {
  projectUrl?: string;
  componentLibraryUrl?: string;
  readonly?: boolean;
  project?: Project;
}

export interface EditorHandle {
  element: DeadBugEditorElement;
  getProject: () => Project;
  setProject: (project: Project) => void;
  destroy: () => void;
}

export function mountEditor(container: HTMLElement, options: MountOptions = {}): EditorHandle {
  registerDeadBugEditor();

  const el = document.createElement('deadbug-editor') as DeadBugEditorElement;
  if (options.projectUrl) el.setAttribute('project-url', options.projectUrl);
  if (options.componentLibraryUrl) el.setAttribute('component-library-url', options.componentLibraryUrl);
  if (options.readonly) el.setAttribute('readonly', 'true');

  container.appendChild(el);

  if (options.project) el.setProject(options.project);

  return {
    element: el,
    getProject: () => el.getProject(),
    setProject: (p) => el.setProject(p),
    destroy: () => el.remove(),
  };
}
